
// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { API as BASE_API } from "./config"; // ✅ Configuración centralizada
// import {
//   FaHome,
//   FaUserPlus,
//   FaFileAlt,
//   FaBullhorn,
//   FaBook,
//   FaSignOutAlt,
//   FaUsers,
//   FaBookOpen,
//   FaExclamationCircle,
//   FaTools,
//   FaUserGraduate,
//   FaWhatsapp,
//   FaChalkboardTeacher
// } from "react-icons/fa";
// import "../style/Sidebar.css";

// // Priorizar la configuración centralizada para evitar fallos de conexión
// const API_URL = BASE_API || "http://3.236.217.225:5001";

// function Sidebar() {
//   const { user, logout } = useAuth();
//   const navigate = useNavigate();

//   const [isCollapsed, setIsCollapsed] = useState(
//     localStorage.getItem("sidebar-collapsed") === "true"
//   );
//   const [isMobileOpen, setIsMobileOpen] = useState(false);

//   useEffect(() => {
//     localStorage.setItem("sidebar-collapsed", isCollapsed);
//   }, [isCollapsed]);

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

//   const toggleSidebar = () => setIsCollapsed(!isCollapsed);
//   const toggleMobileSidebar = () => setIsMobileOpen(!isMobileOpen);

//   // Lógica de foto de perfil corregida
//   const fotoURL = user?.foto
//     ? `${API_URL}${user.foto.startsWith('/') ? '' : '/'}${user.foto}`
//     : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//         (user?.nombre || "U") + " " + (user?.apellido || "")
//       )}&background=1e40af&color=fff&size=128`;

//   return (
//     <>
//       <div className="mobile-menu-btn" onClick={toggleMobileSidebar}>☰</div>
//       {isMobileOpen && <div className="overlay" onClick={toggleMobileSidebar} />}

//       <aside className={`sidebar ${isCollapsed ? "collapsed" : ""} ${isMobileOpen ? "active" : ""}`}>
//         <div className="sidebar-header">
//           <div className="profile-info">
//             <img src={fotoURL} alt="Perfil" className="profile-pic" />
//             {!isCollapsed && (
//               <div className="profile-data">
//                 <span className="profile-name">
//                   {user?.nombre?.split(" ")[0]} {user?.apellido?.split(" ")[0]}
//                 </span>
//                 <span className="profile-role">{user?.role}</span>
//               </div>
//             )}
//           </div>
//           <button className="toggle-btn" onClick={toggleSidebar}>
//             {isCollapsed ? "☰" : "✖"}
//           </button>
//         </div>

//         <ul className="menu">
//           {/* ================== RECTOR / COORDINADOR ================== */}
//           {["rector", "coordinador"].includes(user?.role) && (
//             <>
//               <li><Link to="/dashboard-rector"><FaHome /><span>Inicio</span></Link></li>
//               <li><Link to={`/perfil-rector/${user.id}`}><FaUsers /><span>Mi Perfil</span></Link></li>
//               <li><Link to="/crear-usuario"><FaUserPlus /><span>Crear Usuario</span></Link></li>
//               <li><Link to="/matricula"><FaFileAlt /><span>Matrícula</span></Link></li>
//               <li><Link to="/enviar-comunicado"><FaBullhorn /><span>Comunicado</span></Link></li>
//               <li><Link to="/agregar-materia"><FaBook /><span>Agregar Materia</span></Link></li>
//               <li><Link to="/asignar-materias"><FaFileAlt /><span>Asignar Materias</span></Link></li>
//               <li><Link to="/asignar-profesores-grupo"><FaFileAlt /><span>Asignar Profesores</span></Link></li>
//               <li><Link to="/configuracion-notas"><FaFileAlt /><span>Configurar Notas</span></Link></li>
//               <li><Link to="/excusas-rector"><FaFileAlt /><span>Excusas</span></Link></li>
//               <li><Link to="/crear-horario"><FaFileAlt /><span>Crear Horario</span></Link></li>
//               <li><Link to="/cronograma"><FaBook /><span>Cronograma</span></Link></li>
//               {/* <li><Link to="/auditoria"><FaBook /><span>Auditoría</span></Link></li> */}
//               <li><Link to="/publicaciones"><FaBook /><span>Publicaciones</span></Link></li>
//               <li><Link to="/horario-estudiante"><FaFileAlt /><span>Horario Estudiante</span></Link></li>
//               <li><Link to="/explusacion"><FaFileAlt /><span>Explusación</span></Link></li>
//               <li><Link to="/manual"><FaFileAlt /><span>Manual de Convivencia</span></Link></li>
//               <li><Link to="/director-de-grupo"><FaFileAlt /><span>Dirección de Grupo</span></Link></li>
//               {/* <li><Link to="/comportamiento"><FaFileAlt /><span>Configuración Disciplinaria</span></Link></li> */}
//               <li><Link to="/sede"><FaFileAlt /><span>Sedes</span></Link></li>
//               <li><Link to="/horas-social"><FaFileAlt /><span>Horas Sociales</span></Link></li>
//               <li><Link to="/boletines-masivo"><FaFileAlt /><span>Boletines Masivo</span></Link></li>
//               <li><Link to="/subir-logo"><FaFileAlt /><span>Subir Logo</span></Link></li>
//               {/* <li><Link to="/elecciones-rector"><FaFileAlt /><span>Elecciones Rector</span></Link></li> */}
//               <li><Link to="/informes-rector"><FaFileAlt /><span>Informes Rector</span></Link></li>
//               <li><Link to="/ficha-seguimiento-revision"><FaFileAlt /><span>Ficha Seguimiento</span></Link></li>
//                <li><Link to="/elecciones"><FaFileAlt /><span>Elecciones</span></Link></li>
//                <li><Link to="/foto-perfil-estudiante"><FaFileAlt /><span>Foto Perfil Estudiante</span></Link></li>
//             </>
//           )}

//           {/* ================== PROFESOR ================== */}
//           {user?.role === "profesor" && (
//             <>
//               <li><Link to="/dashboard-profesor"><FaHome /><span>Inicio</span></Link></li>
//               <li><Link to={`/perfil-profesor/${user.id}`}><FaUsers /><span>Mi Perfil</span></Link></li>
//               <li><Link to="/mis-asignaciones-profesor"><FaBook /><span>Mis Asignaciones</span></Link></li>
//               <li><Link to="/lista-estudiantes"><FaUsers /><span>Lista Estudiantes</span></Link></li>
//               <li><Link to="/tareas-profesor"><FaBook /><span>Tareas</span></Link></li>
//               {/* <li><Link to="/evaluaciones-clase"><FaBook /><span>Evaluaciones</span></Link></li> */}
//               <li><Link to="/asistencias-profesor"><FaUsers /><span>Asistencias</span></Link></li>
//               <li><Link to="/excusas-profesor"><FaFileAlt /><span>Excusas</span></Link></li>
//               <li><Link to="/mi-horario"><FaBook /><span>Mi Horario</span></Link></li>
//               <li><Link to="/notas"><FaBook /><span>Notas</span></Link></li>
//               <li><Link to="/gestion-contenido/1"><FaBook /><span>Gestión Contenido</span></Link></li>
//               <li><Link to="/planeacion/1"><FaBook /><span>Planeación</span></Link></li>
//               <li><Link to="/notas-finales"><FaBook /><span>Notas Finales</span></Link></li>
//               <li><Link to="/manual-convivencia-profesor"><FaBookOpen /><span>Manual de Convivencia</span></Link></li>
//               <li><Link to="/direccion-profesor"><FaBookOpen /><span>Dirección de Grupo</span></Link></li>
//               <li><Link to="/horas-sociales-profesor"><FaExclamationCircle /><span>Horas Sociales</span></Link></li>
//               {/* <li><Link to="/boletin"><FaExclamationCircle /><span>Boletines</span></Link></li> */}
//               <li><Link to="/recuperaciones-profesor"><FaExclamationCircle /><span>Recuperación</span></Link></li>
//               <li><Link to="/pendientes"><FaExclamationCircle /><span>Pendientes</span></Link></li>
//               <li><Link to="/observaciones"><FaExclamationCircle /><span>Observaciones</span></Link></li>
//               <li><Link to="/ficha-seguimiento"><FaChalkboardTeacher /><span>Ficha de Seguimiento</span></Link></li>
//               <li><Link to="/boletin-profesor"><FaFileAlt /><span>Boletines</span></Link></li>
//               <li><Link to="/foto-perfil-estudiante"><FaFileAlt /><span>Foto Perfil Estudiante</span></Link></li>
//             </>
//           )}

//           {/* ================== ESTUDIANTE ================== */}
//           {user?.role === "estudiante" && (
//             <>
//             <li><Link to="/dasboard-estudiante"><FaHome /><span>Inicio</span></Link></li>
//               <li><Link to={`/perfil-estudiante/${user.id}`}><FaUsers /><span>Mi Perfil</span></Link></li>
//               <li><Link to="/tareas-estudiante"><FaBook /><span>Mis Tareas</span></Link></li>
//               <li><Link to="/mis-asignaciones-estudiante"><FaBook /><span>Mis Asignaciones</span></Link></li>
//               <li><Link to="/mis-calificaciones"><FaBook /><span>Mis Calificaciones</span></Link></li>
//               <li><Link to="/excusas-estudiante"><FaFileAlt /><span>Excusas</span></Link></li>
//               <li><Link to="/horario-student"><FaFileAlt /><span>Horario</span></Link></li>
//               <li><Link to="/guias"><FaBook /><span>Guías</span></Link></li>
//               <li><Link to="/manual-convivencia-estudiante"><FaBookOpen /><span>Manual de Convivencia</span></Link></li>
//               <li><Link to="/horas-sociales"><FaBookOpen /><span>Horas Sociales</span></Link></li>
//               <li><Link to="/elecciones-estudiante"><FaBookOpen /><span>Elecciones Estudiante</span></Link></li>
//             </>
//           )}

//           {/* ================== PADRE ================== */}
//           {user?.role === "padre" && (
//             <>
//               <li><Link to={`/perfil-padre/${user.id}`}><FaUsers /><span>Mi Perfil</span></Link></li>
//               <li><Link to="/dashboard-padre"><FaUsers /><span>Dashboard</span></Link></li>
//               <li><Link to="/tareas-padre"><FaBook /><span>Mis Tareas</span></Link></li>
//               <li><Link to="/ver-contenido/1"><FaBook /><span>Contenidos</span></Link></li>
//               <li><Link to="/rendimiento-padre/:estudianteId"><FaBook /><span>Rendimiento Estudiante</span></Link></li>
//               <li><Link to="/excusas-padre/:estudianteId"><FaBook /><span>Excusas Estudiante</span></Link></li>
//               <li><Link to="/notas-padre/:estudianteId"><FaBook /><span>Notas Estudiante</span></Link></li>
//               <li><Link to="/asistencia-padre/:estudianteId"><FaBook /><span>Asistencia Estudiante</span></Link></li>
//               <li><Link to="/boletin-padre"><FaBook /><span>Boletín</span></Link></li>
//             </>
//           )}

//           {/* ================== SECRETARIA / COORDINADOR ================== */}
//           {["secretaria", "coordinador"].includes(user?.role) && (
//             <>
//               <li><Link to="/dashboard-secretaria"><FaUserGraduate /><span>Dashboard Secretaria</span></Link></li>
//               <li><Link to="/secretaria/estudiantes"><FaUserGraduate /><span>Buscar Estudiantes</span></Link></li>
//               <li><Link to="/secretaria/certificaciones"><FaUserGraduate /><span>Certificado</span></Link></li>
//               <li><Link to="/verificar-certificado/:codigo"><FaUserGraduate /><span>Código</span></Link></li>
//               <li><Link to="/matriculasecretaria"><FaFileAlt /><span>Matrícula</span></Link></li>
//               <li><Link to="/informes"><FaFileAlt /><span>Informes</span></Link></li>
//               <li><Link to="/documentos"><FaFileAlt /><span>Gestión Documentos</span></Link></li>
//               <li><Link to="/foto-perfil-estudiante"><FaFileAlt /><span>Foto Perfil Estudiante</span></Link></li>
//             </>
//           )}

//           {/* ================== DESARROLLADOR ================== */}
//           {user?.role === "desarrollador" && (
//             <>
//               <li><Link to="/dev-dashboard"><FaTools /><span>Panel Desarrollador</span></Link></li>
//               <li><Link to="/crear-institucion"><FaUsers /><span>Crear Institución</span></Link></li>
//             </>
//           )}

// <li>
//   <Link to="/soporte">
//     <FaWhatsapp color="#25D366" />
//     <span>Soporte</span>
//   </Link>
// </li>


//           {/* ================== LOGOUT ================== */}
//           <li className="logout">
//             <button onClick={handleLogout}><FaSignOutAlt /><span>Cerrar sesión</span></button>
//           </li>
//         </ul>
//       </aside>
//     </>
//   );
// }

// export default Sidebar;



//

import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API as BASE_API } from "./config";
import {
  FaHome,
  FaUserPlus,
  FaFileAlt,
  FaBullhorn,
  FaBook,
  FaSignOutAlt,
  FaUsers,
  FaBookOpen,
  FaExclamationCircle,
  FaTools,
  FaUserGraduate,
  FaWhatsapp,
  FaChalkboardTeacher
} from "react-icons/fa";
import "../style/Sidebar.css";

const API_URL = BASE_API || "http://3.236.217.225:5001";

function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [isCollapsed, setIsCollapsed] = useState(
    localStorage.getItem("sidebar-collapsed") === "true"
  );
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [fotoActual, setFotoActual] = useState("");

  useEffect(() => {
    localStorage.setItem("sidebar-collapsed", isCollapsed);
  }, [isCollapsed]);

  useEffect(() => {
    if (user?.foto) {
      let finalFoto = "";

      if (
        user.foto.startsWith("http://") ||
        user.foto.startsWith("https://")
      ) {
        finalFoto = user.foto;
      } else {
        finalFoto = `${API_URL}${user.foto.startsWith("/") ? "" : "/"}${user.foto}`;
      }

      setFotoActual(finalFoto + `?t=${Date.now()}`); 
    } else {
      setFotoActual(
        `https://ui-avatars.com/api/?name=${encodeURIComponent(
          (user?.nombre || "U") + " " + (user?.apellido || "")
        )}&background=1e40af&color=fff&size=128`
      );
    }
  }, [user]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);
  const toggleMobileSidebar = () => setIsMobileOpen(!isMobileOpen);

  const nombreVisible = useMemo(() => {
    return `${user?.nombre?.split(" ")[0] || ""} ${user?.apellido?.split(" ")[0] || ""}`.trim();
  }, [user]);

  return (
    <>
      <div className="mobile-menu-btn" onClick={toggleMobileSidebar}>☰</div>
      {isMobileOpen && <div className="overlay" onClick={toggleMobileSidebar} />}

      <aside className={`sidebar ${isCollapsed ? "collapsed" : ""} ${isMobileOpen ? "active" : ""}`}>
        <div className="sidebar-header">
          <div className="profile-info">
            <img
              src={fotoActual}
              alt="Perfil"
              className="profile-pic"
              onError={(e) => {
                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                  (user?.nombre || "U") + " " + (user?.apellido || "")
                )}&background=1e40af&color=fff&size=128`;
              }}
            />

            {!isCollapsed && (
              <div className="profile-data">
                <span className="profile-name">{nombreVisible}</span>
                <span className="profile-role">{user?.role}</span>
              </div>
            )}
          </div>

          <button className="toggle-btn" onClick={toggleSidebar}>
            {isCollapsed ? "☰" : "✖"}
          </button>
        </div>

        <ul className="menu">

          {["rector", "coordinador"].includes(user?.role) && (
            <>
            
              <li><Link to="/dashboard-rector"><FaHome /><span>Inicio</span></Link></li>
              <li><Link to={`/perfil-rector/${user.id}`}><FaUsers /><span>Mi Perfil</span></Link></li>
              <li><Link to="/crear-usuario"><FaUserPlus /><span>Crear Usuario</span></Link></li>
              <li><Link to="/matricula"><FaFileAlt /><span>Matrícula</span></Link></li>
              <li><Link to="/enviar-comunicado"><FaBullhorn /><span>Comunicado</span></Link></li>
              <li><Link to="/agregar-materia"><FaBook /><span>Agregar Materia</span></Link></li>
              <li><Link to="/asignar-materias"><FaFileAlt /><span>Asignar Materias</span></Link></li>
              <li><Link to="/asignar-profesores-grupo"><FaFileAlt /><span>Asignar Profesores</span></Link></li>
              <li><Link to="/configuracion-notas"><FaFileAlt /><span>Configurar Notas</span></Link></li>
              <li><Link to="/excusas-rector"><FaFileAlt /><span>Excusas</span></Link></li>
              <li><Link to="/crear-horario"><FaFileAlt /><span>Crear Horario</span></Link></li>
              <li><Link to="/cronograma"><FaBook /><span>Cronograma</span></Link></li>
              {/* <li><Link to="/publicaciones"><FaBook /><span>Publicaciones</span></Link></li> */}
              <li><Link to="/horario-estudiante"><FaFileAlt /><span>Horario Estudiante</span></Link></li>
              <li><Link to="/expulsacion"><FaFileAlt /><span>Expulsación</span></Link></li>
              <li><Link to="/manual"><FaFileAlt /><span>Manual de Convivencia</span></Link></li>
              <li><Link to="/director-de-grupo"><FaFileAlt /><span>Dirección de Grupo</span></Link></li>
              <li><Link to="/sede"><FaFileAlt /><span>Sedes</span></Link></li>
              <li><Link to="/horas-social"><FaFileAlt /><span>Horas Sociales</span></Link></li>
              <li><Link to="/boletines-masivo"><FaFileAlt /><span>Boletines Masivo</span></Link></li>
              <li><Link to="/subir-logo"><FaFileAlt /><span>Subir Logo</span></Link></li>
              <li><Link to="/informes-rector"><FaFileAlt /><span>Informes Rector</span></Link></li>
              <li><Link to="/ficha-seguimiento-revision"><FaFileAlt /><span>Ficha Seguimiento</span></Link></li>
              <li><Link to="/elecciones"><FaFileAlt /><span>Elecciones</span></Link></li>
              <li><Link to="/foto-perfil-estudiante"><FaFileAlt /><span>Foto Perfil </span></Link></li>
              {/* <li><Link to="/auditoria"><FaFileAlt /><span>Auditoria</span></Link></li> */}
              {/* <li><Link to="/hoja-vida-estudiante/:id"><FaFileAlt /><span>Hoja de Vida</span></Link></li> */}
               <li><Link to="/simulacro-rectoria"><FaFileAlt /><span>Simulacro</span></Link></li>
               <li><Link to="/analitica-simulacro-rector"><FaFileAlt /><span>Analítica Simulacro</span></Link></li>
                <li><Link to="/planeaciones-rector"><FaFileAlt /><span>Planeaciones</span></Link></li>
                <li><Link to="/matricula-masiva"><FaFileAlt /><span>Matrícula Masiva</span></Link></li>
                  <li><Link to="/autoevaluacion-gestion"><FaFileAlt /><span>Autoevaluación</span></Link></li>
            </>
          )}

          {user?.role === "profesor" && (
            <>
              <li><Link to="/dashboard-profesor"><FaHome /><span>Inicio</span></Link></li>
              <li><Link to={`/perfil-profesor/${user.id}`}><FaUsers /><span>Mi Perfil</span></Link></li>
              <li><Link to="/mis-asignaciones-profesor"><FaBook /><span>Mis Asignaciones</span></Link></li>
              <li><Link to="/lista-estudiantes"><FaUsers /><span>Lista Estudiantes</span></Link></li>
              <li><Link to="/tareas-profesor"><FaBook /><span>Tareas</span></Link></li>
              <li><Link to="/asistencias-profesor"><FaUsers /><span>Asistencias</span></Link></li>
              <li><Link to="/excusas-profesor"><FaFileAlt /><span>Excusas</span></Link></li>
              <li><Link to="/mi-horario"><FaBook /><span>Mi Horario</span></Link></li>
              <li><Link to="/notas"><FaBook /><span>Notas</span></Link></li>
              <li><Link to="/gestion-contenido/1"><FaBook /><span>Gestión Contenido</span></Link></li>
              <li><Link to="/planeacion/1"><FaBook /><span>logros</span></Link></li>
              <li><Link to="/notas-finales"><FaBook /><span>Notas Finales</span></Link></li>
              <li><Link to="/manual-convivencia-profesor"><FaBookOpen /><span>Manual de Convivencia</span></Link></li>
              <li><Link to="/direccion-profesor"><FaBookOpen /><span>Dirección de Grupo</span></Link></li>
              <li><Link to="/horas-sociales-profesor"><FaExclamationCircle /><span>Horas Sociales</span></Link></li>
              <li><Link to="/recuperaciones-profesor"><FaExclamationCircle /><span>Recuperación</span></Link></li>
              <li><Link to="/pendientes"><FaExclamationCircle /><span>Pendientes</span></Link></li>
              <li><Link to="/observaciones"><FaExclamationCircle /><span>Observaciones</span></Link></li>
              <li><Link to="/ficha-seguimiento"><FaChalkboardTeacher /><span>Ficha de Seguimiento</span></Link></li>
              {/* <li><Link to="/boletin-profesor"><FaFileAlt /><span>Boletines</span></Link></li> */}
              <li><Link to="/foto-perfil-estudiante"><FaFileAlt /><span>Foto Perfil </span></Link></li>
              {/* <li><Link to="/hoja-vida-estudiante/profesor"><FaFileAlt /><span>Hoja de Vida</span></Link></li> */}
              <li><Link to="/simulacros-profesor"><FaBook /><span>Simulacros</span></Link></li>
                <li><Link to="/votacion"><FaBook /><span>Votación</span></Link></li>
                <li><Link to="/planeaciones"><FaBook /><span>Planeaciones</span></Link></li>
                <li><Link to="/autoevaluacion-responder/:id"><FaBook /><span>Autoevaluación</span></Link></li>

      
            </>
          )}

          {user?.role === "estudiante" && (
            <>
              <li><Link to="/dasboard-estudiante"><FaHome /><span>Inicio</span></Link></li>
              <li><Link to={`/perfil-estudiante/${user.id}`}><FaUsers /><span>Mi Perfil</span></Link></li>
              <li><Link to="/tareas-estudiante"><FaBook /><span>Mis Tareas</span></Link></li>
              <li><Link to="/mis-asignaciones-estudiante"><FaBook /><span>Mis Asignaciones</span></Link></li>
              <li><Link to="/mis-calificaciones"><FaBook /><span>Mis Calificaciones</span></Link></li>
              <li><Link to="/excusas-estudiante"><FaFileAlt /><span>Excusas</span></Link></li>
              <li><Link to="/horario-student"><FaFileAlt /><span>Horario</span></Link></li>
              <li><Link to="/guias"><FaBook /><span>Guías</span></Link></li>
              <li><Link to="/manual-convivencia-estudiante"><FaBookOpen /><span>Manual</span></Link></li>
              <li><Link to="/horas-sociales"><FaBookOpen /><span>Horas Sociales</span></Link></li>
              
               <li><Link to="/votacion"><FaBook /><span>Elecciones</span></Link></li>
               <li><Link to="/simulacros-estudiante"><FaBook /><span>Simulacros</span></Link></li>
               <li><Link to="/autoevaluacion-responder/:id"><FaBook /><span>Autoevaluación</span></Link></li>
            </>
          )}

       {user?.role === "padre" && (
            <>
              <li><Link to={`/perfil-padre/${user.id}`}><FaUsers /><span>Mi Perfil</span></Link></li>
              <li><Link to="/dashboard-padre"><FaUsers /><span>Dashboard</span></Link></li>
              <li><Link to="/tareas-padre"><FaBook /><span>Mis Tareas</span></Link></li>
              {/* <li><Link to="/ver-contenido/1"><FaBook /><span>Contenidos</span></Link></li> */}
              <li><Link to="/rendimiento-padre/:estudianteId"><FaBook /><span>Rendimiento Estudiante</span></Link></li>
              <li><Link to="/excusas-padre/:estudianteId"><FaBook /><span>Excusas Estudiante</span></Link></li>
              <li><Link to="/notas-padre/:estudianteId"><FaBook /><span>Notas Estudiante</span></Link></li>
              <li><Link to="/asistencia-padre/:estudianteId"><FaBook /><span>Asistencia Estudiante</span></Link></li>
              <li><Link to="/boletin-padre"><FaBook /><span>Boletín</span></Link></li>
              <li><Link to="/autoevaluacion-responder/:id"><FaBook /><span>Autoevaluación</span></Link></li>
            </>
          )}

          {["secretaria", "coordinador"].includes(user?.role) && (
            <>
              <li><Link to="/dashboard-secretaria"><FaUserGraduate /><span>Dashboard Secretaria</span></Link></li>
              <li><Link to="/secretaria/estudiantes"><FaUserGraduate /><span>Buscar Estudiantes</span></Link></li>
              <li><Link to="/secretaria/certificaciones"><FaUserGraduate /><span>Certificado</span></Link></li>
              <li><Link to="/matriculasecretaria"><FaFileAlt /><span>Matrícula</span></Link></li>
              <li><Link to="/informes"><FaFileAlt /><span>Informes</span></Link></li>
              <li><Link to="/documentos"><FaFileAlt /><span>Gestión Documentos</span></Link></li>
              <li><Link to="/foto-perfil-estudiante"><FaFileAlt /><span>Foto Perfil Estudiante</span></Link></li>
              <li><Link to="/autoevaluacion-gestion"><FaFileAlt /><span>Autoevaluación</span></Link></li>
            </>
          )}

          {user?.role === "desarrollador" && (
            <>
              <li><Link to="/dev-dashboard"><FaTools /><span>Panel Desarrollador</span></Link></li>
              <li><Link to="/crear-institucion"><FaUsers /><span>Crear Institución</span></Link></li>
                <li><Link to="/foto-perfil-estudiante"><FaFileAlt /><span>Foto Perfil Estudiante</span></Link></li>
                <li><Link to="/autoevaluacion-responder/:id"><FaFileAlt /><span>Autoevaluación</span></Link></li>
            </>
          )}

          <li>
            <Link to="/soporte">
              <FaWhatsapp color="#25D366" />
              <span>Soporte</span>
            </Link>
          </li>

          <li className="logout">
            <button onClick={handleLogout}>
              <FaSignOutAlt />
              <span>Cerrar sesión</span>
            </button>
          </li>
        </ul>
      </aside>
    </>
  );
}

export default Sidebar;
